module.exports = __webpack_public_path__ + "media/images/banner-page-bg@2x-2c17ba45d1f2c18b4f299a7d72f54e04.webp";